// ui
import { Button, Typography, Modal, Box, Alert } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../../lib/store";
import { useWindowSize } from "../../lib/useWindowSize";

interface DeletePaymentModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  deletePaymentInf: {
    status: null | "loading" | "open" | "success" | "failed";
    name: string;
    key: { [key: string]: string };
    message: string;
  };
  setDeletePaymentInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    name: string;
    key: { [key: string]: string };
    message: string;
  }) => void;
  deletePayment: () => void;
}

export function DeletePaymentModal(props: DeletePaymentModalProps) {
  const {
    onModal,
    swCloseModal,
    deletePaymentInf,
    setDeletePaymentInf,
    deletePayment,
  } = props;
  const pathname = useAtomValue(AppAtoms.pathname);
  const { windowWidth, windowHeight } = useWindowSize();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: windowWidth > 568 ? "500px" : "calc(100% - 82px)",
    maxHeight: "70vh",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  return (
    <Modal
      open={onModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          style={{
            fontSize: "18px",
            color: "rgb(50 50 50)",
          }}
          key="deleteTitleBox"
          className="shippori-antique-regular"
        >
          {deletePaymentInf.name}
        </Box>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 5 }}>
          {deletePaymentInf.status === "open" ? (
            <>
              <Alert severity="error">
                {deletePaymentInf.name}
                後、データは復元できません。
                {pathname !== "/outside_entry_form" ? (
                  <>
                    <br />
                    確定済の明細には影響は発生しません。
                  </>
                ) : null}
              </Alert>
              <Box style={{ display: windowWidth > 385 ? "flex" : undefined }}>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? undefined : "5px",
                    textTransform: "none",
                  }}
                >
                  <Button
                    style={{
                      height: "40px",
                      width: "100%",
                    }}
                    variant="contained"
                    onClick={deletePayment}
                  >
                    <Box className="m-plus-rounded-1c-regular">削除</Box>
                    <DeleteIcon
                      sx={{ marginLeft: "6px", color: "white" }}
                      fontSize="medium"
                    />
                  </Button>
                </Box>
                <Box
                  style={{
                    marginTop: "10px",
                    height: "40px",
                    width:
                      windowWidth > 385
                        ? "calc(50% - 5px)"
                        : "calc(100% - 10px)",
                    marginLeft: windowWidth > 385 ? "10px" : "5px",
                    textTransform: "none",
                  }}
                >
                  <Button
                    variant="contained"
                    style={{
                      height: "40px",
                      width: "100%",
                    }}
                    onClick={swCloseModal}
                  >
                    <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                  </Button>
                </Box>
              </Box>
            </>
          ) : deletePaymentInf.status === "success" ? (
            <>
              <Box className="shippori-antique-regular">
                {deletePaymentInf.name}
                に成功しました。
              </Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={swCloseModal}
                >
                  <Box className="m-plus-rounded-1c-regular">閉じる</Box>
                </Button>
              </Box>
            </>
          ) : deletePaymentInf.status === "failed" ? (
            <>
              <Box className="shippori-antique-regular">
                {deletePaymentInf.message}
              </Box>
              <Box>
                <Button
                  style={{
                    marginTop: "30px",
                    marginLeft: windowWidth > 385 ? "15%" : "5px",
                    marginBottom: "-25px",
                    height: "40px",
                    width: windowWidth > 385 ? "70%" : "calc(100% - 10px)",
                    textTransform: "none",
                  }}
                  variant="contained"
                  onClick={() =>
                    setDeletePaymentInf({
                      ...deletePaymentInf,
                      status: "open",
                      message: "",
                    })
                  }
                >
                  <Box className="m-plus-rounded-1c-regular">戻る</Box>
                </Button>
              </Box>
            </>
          ) : null}
        </Typography>
      </Box>
    </Modal>
  );
}
